import { Input } from "@shared/ui";
import styles from "../styles.module.scss";

type EmployeeSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
};

export function EmployeeSearchInput({
  value,
  onChange,
}: EmployeeSearchInputProps) {
  return (
    <Input.Search
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Search employees by name or email…"
      allowClear
      className={styles.searchInput}
    />
  );
}
